export default "__VITE_ASSET__dY$8tguw__"